/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Payments_Order_NoInputs */

const en_admin_payments_order_no = /** @type {(inputs: Admin_Payments_Order_NoInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Order No`)
};

/**
* | output |
* | --- |
* | "Order No" |
*
* @param {Admin_Payments_Order_NoInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const admin_payments_order_no = /** @type {((inputs?: Admin_Payments_Order_NoInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Payments_Order_NoInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_admin_payments_order_no(inputs)
});
export { admin_payments_order_no as "admin.payments.order_no" }